/* eslint-disable no-bitwise */

/**
 *  @notes JPEG ignores extra bytes after EOI (0xFFD9)
 */
async function inflateImageToSizeJPEG(
  input: File | Blob,
  targetSizeBytes: number,
) {
  const arrayBuffer = await input.arrayBuffer()
  const originalBytes = new Uint8Array(arrayBuffer)

  const result = new Uint8Array(targetSizeBytes)
  result.set(originalBytes, 0)

  for (let i = input.size; i < targetSizeBytes; i += 1) {
    /** fill bytes after EOI with zeros */
    result[i] = 0
  }

  return new Blob([result], {type: input.type})
}

async function inflateImageToSizePNG(
  input: File | Blob,
  targetSizeBytes: number,
) {
  const arrayBuffer = await input.arrayBuffer()
  const originalBytes = new Uint8Array(arrayBuffer)

  /** PNG signature is first 8 bytes */
  const pngSignature = originalBytes.slice(0, 8)
  const rest = originalBytes.slice(8)

  /** Append dummy tEXt chunk */
  const paddingSize = targetSizeBytes - input.size
  const textChunkSize = paddingSize - 12 // chunk header/footer
  const textData = new Uint8Array(textChunkSize).fill(0)
  const chunk = new Uint8Array(textChunkSize + 12)

  /** Chunk length */
  chunk[0] = (textChunkSize >> 24) & 0xff
  chunk[1] = (textChunkSize >> 16) & 0xff
  chunk[2] = (textChunkSize >> 8) & 0xff
  chunk[3] = textChunkSize & 0xff

  /** Chunk type "tEXt" */
  chunk[4] = 0x74 // t
  chunk[5] = 0x45 // E
  chunk[6] = 0x58 // X
  chunk[7] = 0x74 // t

  /** Chunk data */
  chunk.set(textData, 8)

  /** CRC (set to 0 for simplicity) */
  chunk[chunk.length - 4] = 0
  chunk[chunk.length - 3] = 0
  chunk[chunk.length - 2] = 0
  chunk[chunk.length - 1] = 0

  const result = new Uint8Array(
    pngSignature.length + rest.length + chunk.length,
  )

  result.set(pngSignature, 0)
  result.set(rest, pngSignature.length)
  result.set(chunk, pngSignature.length + rest.length)

  return new Blob([result], {type: input.type})
}

/**
 * @throws Unsupported file type
 */
export async function inflateImageToSize(
  input: File | Blob,
  targetSizeBytes: number,
): Promise<Blob> {
  if (input.size >= targetSizeBytes) return input

  const mimeType = input.type.toLowerCase()

  if (mimeType === 'image/jpeg' || mimeType === 'image/jpg')
    return inflateImageToSizeJPEG(input, targetSizeBytes)

  if (mimeType === 'image/png')
    return inflateImageToSizePNG(input, targetSizeBytes)

  throw new Error('Unsupported file type')
}
